import {
    bindEmailUrl,
    unBindUrl,
    validEmailUrl,
    authCodeUrl,
    gigyaUnbindUrl
} from 'Utils/urlUtil'
import { post, get } from 'Utils/apiUtil'
import { loadProfile, removeProfile } from 'Utils/jwtUtil'
import { setUserData } from 'Actions/localData'

export const USER_BIND = "USER_BIND"
export const UN_BIND = "UN_BIND"
export const AUTH_CODE = 'AUTH_CODE'
export const EMAIL_VALID = 'EMAIL_VALID'
export const CODE_VALID = 'CODE_VALID'

// Send To Backend Request Bind Email
export function bindEmail(params, func) {
    let profile = loadProfile();
    let openId = profile ? profile.openId : '';
    const data = params;
          data.openId = openId;

    return dispatch => dispatch(post(bindEmailUrl, data)).then((res) => {
        dispatch({ type: USER_BIND, payload: res });
        setUserData(res)
        func && func(res)
    }).catch((res) => {
        dispatch({ type: USER_BIND, payload: res });
        func && func(res)
    });
}

// Send To Backend Request Unbind Email
export function unBindWechat(callback) {
    return dispatch => dispatch(get(unBindUrl)).then((response) => {
        removeProfile();
        dispatch({
            type: UN_BIND,
            payload: response
        });
        callback && callback('complete');
    });
}

export function authCode (params, func) {
    return dispatch => dispatch(get(authCodeUrl, { email: params })).then((res) => {
        dispatch({ type: AUTH_CODE, payload: res });
        func && func(res)
    }).catch((res) => {
        dispatch({ type: AUTH_CODE, payload: res });
        func && func(res)
    });
}

export function validEmail (params, func) {
    return dispatch => dispatch(get(validEmailUrl, { email: params, type: 2 })).then((res) => {
        dispatch({ type: EMAIL_VALID, payload: res });
        func && func(res)
    }).catch((res) => {
        dispatch({ type: EMAIL_VALID, payload: res });
        func && func(res)
    });
}

// Gigya Unbind
export function unBindGigya(callback) {
    return dispatch => dispatch(post(gigyaUnbindUrl)).then((response) => {
        removeProfile();
        dispatch({
            type: UN_BIND,
            payload: response
        });
        callback && callback(response);
    });
}
